module.exports = __webpack_public_path__ + "static/media/dks55.8cbd8989.png";